(() => {
  if (customElements.get('ap-cart-subscription')) return;
  let pending = false;
  const isCheckout = target => target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .additional-checkout-buttons');
  document.addEventListener('click', event => {
    if (pending && (isCheckout(event.target) || event.target.closest('cart-remove-button'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (pending && (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form' || event.submitter?.name === 'checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  class CartSubscription extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggle = this.querySelector('[data-subscription-toggle]');
      this.plan = this.querySelector('[data-subscription-plan]');
      this.status = this.querySelector('[data-subscription-status]');
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target !== this.toggle && event.target !== this.plan) return;
        this.showPlan();
        if (event.target === this.plan && !this.toggle.checked) return;
        this.updatePlan(event.target);
      });
    }

    showPlan() {
      this.querySelectorAll('[data-subscription-details]').forEach(detail => {
        detail.hidden = detail.dataset.subscriptionDetails !== this.plan.value;
      });
    }

    restoreSelection() {
      this.toggle.checked = Boolean(this.dataset.currentPlan);
      if (this.dataset.currentPlan) this.plan.value = this.dataset.currentPlan;
      this.showPlan();
    }

    sectionsToRender() {
      const sections = [];
      for (const id of ['main-cart-items', 'main-cart-footer']) {
        const element = document.getElementById(id);
        if (element) sections.push({ element, section: element.dataset.id, selector: '.js-contents' });
      }
      const drawer = document.querySelector('#CartDrawer .drawer__inner');
      if (drawer) sections.push({ element: drawer, section: 'cart-drawer', selector: '.drawer__inner' });
      return sections;
    }

    async updatePlan(trigger) {
      if (pending || document.querySelector('.cart__items--disabled')) {
        this.restoreSelection();
        return;
      }
      const sellingPlan = this.toggle.checked ? Number(this.plan.value) : null;
      const line = Number(this.dataset.line);
      const row = this.closest('.cart-item, .drawer__cart-item');
      const quantity = Number(row?.querySelector('[name="updates[]"]')?.value || this.dataset.quantity);
      if (!Number.isSafeInteger(line) || line < 1 || !Number.isSafeInteger(quantity) || quantity < 1 || (sellingPlan !== null && (!Number.isSafeInteger(sellingPlan) || sellingPlan < 1))) {
        this.restoreSelection();
        this.status.textContent = this.dataset.error;
        return;
      }
      pending = true;
      document.documentElement.dataset.apCartSubscriptionPending = 'true';
      const disabled = [];
      document.querySelectorAll('cart-items input, cart-items select, cart-items button, cart-drawer input, cart-drawer select, cart-drawer button, [name="checkout"], product-form [type="submit"]').forEach(control => {
        if (!control.disabled) {
          disabled.push(control);
          control.disabled = true;
        }
      });
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.updating;
      const sections = this.sectionsToRender();
      const scope = this.closest('cart-drawer-items') ? 'Drawer' : 'Page';
      let changed = false;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          credentials: 'same-origin',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, selling_plan: sellingPlan, sections: sections.map(section => section.section), sections_url: window.location.pathname })
        });
        const cart = await response.json();
        if (!response.ok || cart.errors) throw new Error(typeof cart.description === 'string' ? cart.description : this.dataset.error);
        changed = true;
        const replacements = sections.map(section => {
          const html = cart.sections?.[section.section];
          if (!html) throw new Error(this.dataset.error);
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
          if (!source) throw new Error(this.dataset.error);
          return { target: section.element.querySelector(section.selector) || section.element, html: source.innerHTML };
        });
        replacements.forEach(replacement => { replacement.target.innerHTML = replacement.html; });
        document.querySelectorAll('[data-cart-count]').forEach(badge => {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
        const focus = document.getElementById(`${scope}-subscription-${line - 1}${trigger === this.plan ? '-plan' : ''}`);
        if (focus && !focus.disabled) focus.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        if (changed || error instanceof TypeError || error instanceof SyntaxError || error.name === 'AbortError') {
          window.location.reload();
          return;
        }
        this.restoreSelection();
        this.status.textContent = error.message || this.dataset.error;
      } finally {
        clearTimeout(timeout);
        disabled.forEach(control => { control.disabled = false; });
        this.removeAttribute('aria-busy');
        pending = false;
        delete document.documentElement.dataset.apCartSubscriptionPending;
      }
    }
  }
  customElements.define('ap-cart-subscription', CartSubscription);
})();
